document.addEventListener('DOMContentLoaded', () => {
  const customAccordionItems = document.querySelectorAll('.custom-accordion-item');
  const customSlidePanel = document.getElementById('custom-accordion-slide-panel');
  const customSlidePanelContent = document.getElementById('custom-slide-panel-content');
  const closeCustomSlidePanel = document.querySelector('.accordion_drawer__close'); // Aangepast naar nieuwe class
  const customOverlay = document.getElementById('custom-accordion-overlay');

  // Event listener om de drawer te vullen en te openen
  document.querySelectorAll('.custom-accordion-item summary').forEach(summary => {
    summary.addEventListener('click', (e) => {
      e.preventDefault(); // Voorkom standaard uitklapgedrag

      // Voeg alle accordion-items toe aan de drawer
      customSlidePanelContent.innerHTML = Array.from(customAccordionItems).map(item => {
        const title = item.querySelector('summary').innerHTML;
        const content = item.querySelector('.accordion__content').innerHTML;

        return `
          <details class="custom-accordion-item" open>
            <summary>${title}</summary>
            <div class="accordion__content rte">${content}</div>
          </details>
        `;
      }).join('');

      // Open de drawer en overlay
      customSlidePanel.classList.add('open');
      customOverlay.classList.add('open');
    });
  });

  // Sluit de drawer bij klik op sluitknop of overlay
  closeCustomSlidePanel.addEventListener('click', closeDrawer);
  customOverlay.addEventListener('click', closeDrawer);

  function closeDrawer() {
    customSlidePanel.classList.remove('open');
    customOverlay.classList.remove('open');
  }
});
